import { z } from 'zod';
export const marketSchema = z.object({
    city: z.string(),
    state: z.string(),
    active: z.boolean(),
});
export const marketQueryParamsSchema = z.object({
    active: z.literal(['true', 'false']).optional(),
});
